import { hasValue } from './utils';

/**
 * Self-contained system error. Mirrors the public shape of `platform/Error`'s
 * `SystemError` (name, cause, __isError) so production error handlers behave
 * identically — but does NOT import `platform/Error` so this module stays free
 * of the observability/bricks-next transitive chain that breaks plain-ESM
 * loaders (Playwright's TS runner).
 */
class AssertionSystemError extends Error {
  override name = 'SystemError';
  override cause = 'system-error' as const;
  __isError = true;
  constructor(message: string) {
    super(message, { cause: 'system-error' });
  }
}

/**
 * Asserts that a value is not null nor undefined.
 * @throws SystemError if null or undefined
 */
export const assertHasValue = <T>(name: string, value: T | null | undefined): T => {
  if (hasValue(value)) {
    return value;
  }
  throw new AssertionSystemError(`expected ${name} not to be empty, but was ${value}`);
};
